var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrowth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 95 118.75",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m24.18,65.96h-12.14v20.54h12.14v-20.54h0Zm19.59-11.74h-12.14v32.29h12.14v-32.29h0Zm19.59-13.68h-12.14v45.97h12.14v-45.97h0Zm19.59-13.97h-12.14v59.94h12.14V26.57h0ZM5.66,92.5c-.6,0-1.09-.49-1.09-1.09s.49-1.09,1.09-1.09h83.68c.6,0,1.09.49,1.09,1.09s-.49,1.09-1.09,1.09H5.66ZM56.62,8.42l11.33-5.92,2.26,12.56-2.25-1.1c-.53-.26-1.16-.05-1.43.47-5.69,10.69-13.24,18.57-22.63,23.96-5.32,3.05-11.23,5.3-17.73,6.81,5.82-2.18,10.58-4.83,14.74-8.19,7.41-6,12.83-14.18,18.75-25.85.27-.53.06-1.19-.48-1.46l-2.56-1.27Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowth);
export default __webpack_public_path__ + "static/media/growth.3799caf1ebdbb952bfb1867fa7665d51.svg";
export { ForwardRef as ReactComponent };